export const PRODUCT_ATTRIBUTE = 'Product Attribute';
export const BOM_DETAIL = 'Bom Detail';
export const SERVICE_PROVIDER = 'Service Provider';
